import React from 'react';
import { WebinarLink } from './WebinarLink';
export const Problem = ({
  openModal
}) => {
  // Add the openModal prop and the helper function
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-171">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-172">
      <p className="mb-6 leading-relaxed" data-id="element-173">
        Marcel staarde naar het bericht op zijn scherm. Hij las de woorden drie
        keer voordat hij het begreep.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-174">
        David L. Mech (de man achter de beroemde dominantie theorie) had een
        openbare verklaring afgelegd die zijn jarenlange aanpak volledig
        onderuit haalde.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-175">
        "Mijn dominantie theorie is niet van toepassing op honden. Het spijt me
        dat dit misverstand zo wijdverspreid is geworden onder hondeneigenaren."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-176">
        Marcel voelde zich bedonderd. Vijf jaar lang had hij geprobeerd de
        "alfaleider" te zijn voor zijn Duitse herder Luna. Streng zijn wanneer
        nodig. Consequent corrigeren. Dominantie tonen.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-177">
        Precies zoals elke trainer, elk boek, elke hondenschool hem had geleerd.
      </p>
      <p className="mb-6 leading-relaxed font-semibold text-blue-800" data-id="element-178">
        Maar nu vertelde de grondlegger van deze hele theorie dat het niet eens
        waar was?
      </p>
      <div className="w-full mb-6" data-id="element-179">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/a2Ba3ci6nRADpwkNfjzXYD/Scherm%C2%ADafbeelding_2025-09-01_om_23.29.20.png" alt="Golden retriever wordt met vinger gewezen door eigenaar" className="w-full h-auto rounded-lg shadow-md" data-id="element-180" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-181">
          Straffen en corrigeren maakt meer kapot dan je lief is.
        </p>
      </div>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-182">
        Amee deelt het de waarheid met hondenbaasjes tijdens haar webinar.
      </h2>
      <p className="mb-6 leading-relaxed font-semibold" data-id="element-183">
        In{' '}
        <a href="https://stresslessdogs.nl/meta-mcc-adv" className="text-blue-600 cursor-pointer hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-184">
          dit exclusieve webinar
        </a>{' '}
        ontdek je:
      </p>
      <ul className="mb-6 list-disc pl-5 space-y-2" data-id="element-185">
        <li data-id="element-186">Waarom David Mech zijn eigen dominantie theorie heeft afgekeurd</li>
        <li data-id="element-187">Het verschil tussen wolven in gevangenschap en in het wild</li>
        <li data-id="element-188">Waarom honden sociaal anders functioneren dan wolven</li>
        <li data-id="element-189">Van domineren naar echt begrijpen en samenwerken</li>
        <li data-id="element-190">Hoe stress je hond reactiever maakt en problemen veroorzaakt</li>
      </ul>
      <p className="mb-6 leading-relaxed" data-id="element-191">
        In 90 minuten legt Amee het rustig en duidelijk uit tijdens een
        makkelijke online presentatie.{' '}
        <a href="https://stresslessdogs.nl/meta-mcc-adv" className="text-blue-600 cursor-pointer hover:underline" target="_blank" rel="noopener noreferrer" onClick={openModal} data-id="element-192">
          Aanmelden kan hier.
        </a>
      </p>
    </section>;
};